import { render, staticRenderFns } from "./OrgChartDetails.vue?vue&type=template&id=a699fa7e"
import script from "./OrgChartDetails.vue?vue&type=script&lang=js"
export * from "./OrgChartDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports